"use client";

import React from "react";
import { RegistrationComposite } from "../../../components/composites/Registration/RegistrationComposite";
import { WcStack } from "@bpipartners/webui";
export default function Page() {
  return (
    <WcStack
      sx={{
        // justifyContent: "center",
        alignItems: "center",
      }}
    >
      <RegistrationComposite />
    </WcStack>
  );
}
